import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue'
import { AlarmLevelType } from '@/types/types'
import useI18nTl from '@/hooks/useI18nTl'

import { defineComponent } from 'vue'

const __default__ = defineComponent({
  name: 'AlarmLevel',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  state: {
    type: Number,
  },
},
  setup(__props) {

const props = __props

const { t, tl } = useI18nTl('Evses')



const statusLabel = computed(() => {
  switch (props.state) {
    case AlarmLevelType.FN_COMMON:
      return tl('alarmLevelCommon')
    case AlarmLevelType.FN_MINOR:
      return tl('alarmLevelMinor')
    case AlarmLevelType.FN_IMPORTANT:
      return tl('alarmLevelImportant')
    case AlarmLevelType.FN_CRASH:
      return tl('alarmLevelCrash')
  }
  return t('Base.unknown')
})

const color = computed(() => {
  return '#5e4eff'
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: "text-status",
    style: _normalizeStyle({ color: _unref(color) })
  }, _toDisplayString(_unref(statusLabel)), 5))
}
}

})